"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Feb 14 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowSimulationConverter.
 *
 * @author BPo
 */


var WindowSimulationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowSimulationConverter, _DataObjectConverter_);

  function WindowSimulationConverter() {
    _classCallCheck(this, WindowSimulationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowSimulationConverter).apply(this, arguments));
  }

  return WindowSimulationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowSimulationConverter = WindowSimulationConverter;